<template>
  <div class="share-box">
    <div class="s-type1" v-if="shareType == 1">
      <Popups :isShow="show" @close="close" class="share-pop" position="bottom" container="body" :showFooter="false">
        <div class="share-info">
          <div class="share-label">分享</div>
          <share-item
            :shareParams="shareParams"
            :customParams="customParams"
            :posterParams="posterParams"
            @close="close"
          ></share-item>
        </div>
      </Popups>
    </div>

    <div class="s-type2" v-else-if="shareType == 2">
      <Popups
        class="share-popup"
        :isShow="show"
        title="产品海报"
        @close="close"
        fullScreen
        :showFooter="canBtnSave"
        footer="保存海报"
        @footerClick="footerClick"
        container="#app"
      >
        <div class="title">
          <template v-if="isWx || isQQ || isAlipay">长按将图片保存或直接发送给您的朋友</template>
          <template v-else-if="isBankabc || isVHome || isVivoHealth">
            截图保存图片，保存后可通过微信、QQ等社交工具分享给您的朋友
          </template>
          <template v-else-if="isIOS">长按图片保存，保存后可通过微信、QQ等社交工具分享给您的朋友</template>
          <template v-else>保存后可通过微信、QQ等社交工具分享给您的朋友</template>
        </div>
        <div class="share-img">
          <img :src="posterPath" alt="" />
        </div>
      </Popups>
    </div>
    <div class="s-type0" v-else>
      <share-item :shareParams="shareParams" :customParams="customParams" :posterParams="posterParams"></share-item>
    </div>
  </div>
</template>

<script>
import create from '../create'
import { Popups } from '@/components'
import ShareItem from './share-item'
import clientEnv from '@/utils/clientEnv'

const { isIOS, isVHome, isBankabc, isVivoHealth, isWx, isQQ, isAlipay } = clientEnv

export default create({
  name: 'share',
  components: {
    Popups,
    ShareItem
  },
  props: {
    shareType: {
      type: [String, Number],
      default: 0
    },
    show: {
      type: Boolean
    },
    shareParams: Object,
    customParams: Object,
    posterParams: Object
  },
  data() {
    return {
      canBtnSave: !isIOS && !isBankabc && !isVivoHealth && !isWx && !isQQ && !isAlipay && !isVHome,
      posterPath: '', // 海报图片链接
      isIOS,
      isBankabc,
      isWx,
      isQQ,
      isAlipay,
      isVHome,
      isVivoHealth
    }
  },
  watch: {
    show(val) {
      this.isShowShare = val
    },
    shareParams: {
      handler(shareParams) {
        if (shareParams && shareParams.posterUrl) {
          this.posterPath = shareParams.posterUrl
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    // console.log('shareParams', this.shareParams)
    // let params = {
    //   'shareChannel': '8',
    //   'posterUrl': 'https://shopstatic.vivo.com.cn/vivoshop/poster/20190606/2019060615213985689_original.jpg',
    //   'posterShareTitle': '分享海报给好友'
    // }
    // window.WeiwoJSBridge.call('showShare', params)
  },
  methods: {
    close() {
      this.$emit('close')
    },
    /**
     * 保存海报
     */
    footerClick() {
      this.downLoadFile(this.posterPath)
    },

    /**
     * 下载海报
     */
    downLoadFile(fileName) {
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = fileName
      link.download = fileName
      document.body.appendChild(link)
      link.click() // 触发下载
      document.body.removeChild(link)
    }
  }
})
</script>

<style lang="scss" scoped src="./index.scss"></style>
